import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/unit/Layout';


import HomePage from './pages/spage/home/HomePage';
import AboutPage from './pages/spage/other/AboutPage';
import NotFoundPage from './pages/spage/error/NotFoundPage';

import Design from './pages/spage/products/software/design/design';


function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          {/* <Route path="/:category/:productId" element={<HomePage />} /> */}
          {/* <Route path="/about" element={<AboutPage />} /> */}
          {/* <Route path="/products/software/office" element={<AboutPage />} /> */}
          {/* <Route path="/products/software/design" element={<Design />} /> */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;